<template>
    <div class="registerBox">
        <div class="imgBox">
            <img src="../assets/img/logo.png" >
        </div>
        <md-field>
            <md-input-item
               title="姓名："
               v-model="name"
               clearable
            ></md-input-item>
            <md-field-item title="性别：" solid>
                <md-radio name="M" v-model="gender" label="男" inline />
                <md-radio name="W" v-model="gender" label="女" inline />
            </md-field-item>
            <md-field-item
            title="生日："
            arrow="arrow-right"
            align="center"
            :content="birthday"
            @click.native="isBirthdayState = true"
            ></md-field-item>
            <md-input-item
                    title="手机号："
                    v-model="mPhone"
                    type="phone"
                    clearable
            >
            </md-input-item>
            <md-input-item
                    title="验证码："
                    v-model="securityCode"
                    type="digit"
                    clearable
            >
                <div class="operatorNum" v-if="securityState" slot="right" >{{num}}s</div>
                <div class="input-operator" @click="securityCodeFn" v-else slot="right" >获取验证码</div>
            </md-input-item>

        </md-field>

        <md-date-picker
            ref="datePicker"
            v-model="isBirthdayState"
            type="custom"
            title="选择日期"
            large-radius
            :custom-types="['yyyy', 'MM','dd']"
            :min-date="minDate"
            :max-date="maxDate"
            :default-date="currentDate"
            @confirm="onDatePickerConfirm"
        ></md-date-picker>

        <div class="registerBtn" @click="registerFn">注册</div>
    </div>
</template>

<script>
    export default {
        name: "register",
        data(){
            return {
                name:'', //姓名
                gender:'M', //性别
                birthday:'', //生日
                isBirthdayState:false, //控制生日列表状态
                currentDate: new Date(), //默认时间
                minDate: new Date('1800-01-01'),
                maxDate: new Date('2090-12-30'),
                mPhone:'', //手机号
                securityCode:'', //验证码
                securityState:false, //验证码显示状态
                num:60, //验证码时间
                codeData:JSON.parse(localStorage.getItem("code")), //用户信息
                wei:6
            }
        },
        mounted(){
          document.title = "注册"
            // console.log(JSON.parse(localStorage.getItem("code")))
            this.codeData = JSON.parse(localStorage.getItem("code"))
            
            // console.log(this.codeData)
            // let dt = new Date('1960-01-01')
            // console.log(dt.getTime())
        },
        methods:{
            onDatePickerConfirm() {
                this.birthday = this.$refs.datePicker.getFormatDate('yyyy-MM-dd')
            },
            securityCodeFn(){//获取验证码
                //这里判断手机号是否存在
                let {mPhone} = this
                if(mPhone.length != 11){
                    this.UI.Toast.failed("请输入正确的手机号")
                    return
                }
                this.securityState = true
                this.stop = setInterval(()=>{
                    if(this.num == 0){
                        clearInterval(this.stop)
                        this.securityState = false
                        this.num = 60
                    }else{
                        this.num--
                    }
                },1000)
                let mes = new URLSearchParams()
                mes.append('phone', this.mPhone) //手机
                // mes.append('id', this.mPhone) //用户id
                mes.append('id', this.codeData.openid) //用户openid
                mes.append('num', this.wei) //验证码位数
                this.$http.post('/system/base/securityCode/message', mes).then(({data}) =>{ //获取验证码
                    if(data.code != 200){
                         this.UI.Toast.failed(data.data.message)
                    }
                })
            },
            registerFn(){ //注册方法
                let dt = new URLSearchParams()
                let {name, gender, birthday, mPhone, codeData,securityCode} = this
                if(!name){
                    this.UI.Toast.failed("会员姓名不能为空")
                    return
                }else if(!birthday){
                    this.UI.Toast.failed("生日不能为空")
                    return
                }else if(!(/^1[345789]\d{9}$/.test(mPhone))){
                    this.UI.Toast.failed("手机号格式错误")
                    return
                }
                if(!securityCode){
                    this.UI.Toast.failed("短信验证码不能为空")
                    return
                }
                // console.log(codeData)

                dt.append('name', name) //会员名称
                dt.append('sex', gender)  //性别
                dt.append('phone', mPhone) //电话
                dt.append('wxOpenId', codeData.openid) //openid
                dt.append('wxNickName', codeData.nickname) //昵称
                // dt.append('wxGender', codeData.wxCountry) //国家
                dt.append('wxHeadImgUrl', codeData.headimgurl) //头像
                dt.append('birthday', birthday) //生日
                dt.append('msgCode', securityCode) //验证码
                this.$http.post('/sangto-wrm/vip/member/registerByBirthday', dt).then(({data}) =>{
                    if(data.code == 200 && data.data != null){
                        let da = new URLSearchParams()
                        da.append('openid', data.data.wxOpenId)
                        this.$http.post('/sangto-wrm/vip/member/getByOpenId',da).then(({data})=>{ //使用openid获取会员信息
                            if(data.code == 200 && data.data != null){
                                // console.log(data.data)
                                let dataStr = JSON.stringify(data.data)
                                if(data.data.cardAccount){
                                    localStorage.setItem("login", '1')
                                }else{
                                    localStorage.setItem("login", '0')
                                }

                                localStorage.setItem("userData", dataStr)
                                this.UI.Toast.succeed("注册成功")  //成功
                                this.$router.push('/appMain/home')
                            }else{
                                this.UI.Toast.failed(data.message)
                            }
                        })

                    }else{
                        this.UI.Toast.failed(data.message)  //失败
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.registerBox{
    width: 100%;
    height: 100%;
    background-color: #fff;
    .imgBox{
        width: 100%;
        height: 120px;
        border-bottom: 8px solid #f3f3f3;
        background-color: #fff;
        display: flex;
        img{
            width: 50%;
            height: 48px;
            margin: auto;
        }
    }
    .input-operator{
        margin-right: 11px;
        width: 100px;
        height: 34px;
        background-color: #26a5ff;
        text-align: center;
        line-height: 34px;
        color: #fff;
        border-radius: 4px;
        font-size: 14px;
    }
    .operatorNum{
        margin-right: 11px;
        width: 60px;
        height: 34px;
        text-align: center;
        line-height: 34px;
        color: #ea5a59;
        border-radius: 4px;
        font-size: 14px;
    }
    .registerBtn{
        width: 88%;
        height: 44px;
        background-color:#2f86f6;
        margin: 60px auto 0 auto;
        text-align: center;
        line-height: 44px;
        color: #fff;
        border-radius: 4px;
        letter-spacing: 2px;
    }
}
</style>
